import { Injector } from "@angular/core";
import { FieldDefinition } from "../../../../../sections/meddra/message/fieldDefinition";
import { MeddraService } from "../../../../service/meddra-service/meddra.service";
import { MeddraTerm } from "../../../Data/MeddraData/MeddraTerm";
import { MeddraNode } from "../MeddraNode";
import { TreeNodeMeddraLevelItem } from "./TreeNodeMeddraLevelItem";
import { HLGTListView } from "../../../Data/MeddraData/HLGTListView";
import { PTListView } from "../../../Data/MeddraData/PTListView";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";
import { DummyNode } from "../../DummyNode";
import { HierarchyMode } from '../../../MeddraEnum';
import { EntityEnum } from "../../EntityEnum";
import { BaseNode } from "../../BaseNode";


export class TreeNodeSOCItem extends TreeNodeMeddraLevelItem {

    constructor(injector: Injector, data: any, parent: BaseNode) {
        super(injector, data, EntityEnum.soc, injector.get(Art57Section).meddra.socTermsTreeNode, parent);
        this.children?.push(new DummyNode());
    }


    override createChildren(): void {

                //Retrieve "Primary Preferred Terms for this SOC term"
                let newSOCPTNode = new MeddraNode(this.ioc!, new PTListView([]), `Primary Preferred Terms ({param})`, EntityEnum.pt, null, this, HierarchyMode.DESCENDING)
                this.children!.push(newSOCPTNode);
                this.ioc?.get(MeddraService).getAll(this,EntityEnum.pt, `soc_code:eq:${this.data.model.code}`).subscribe(
                    {
                        next: (data:any) => {
                            newSOCPTNode.data = new PTListView(data.result);
                            data.result.forEach((i: any) => newSOCPTNode.children!.push(new MeddraNode(this.ioc!, new MeddraTerm(new FieldDefinition(this.ioc!).ptFields, i), i.name, EntityEnum.pt, this.ioc!.get(Art57Section).meddra.ptTermsTreeNode, newSOCPTNode, HierarchyMode.DESCENDING)))
                            newSOCPTNode.refreshLabel();
                        }, error: () => {
                            this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                        }
                    });

        //Retrieve "High Level Group Terms for this SOC term"
        let newSOCHLGTNode = new MeddraNode(this.ioc!, new HLGTListView([]), `High Level Group Terms ({param})`, EntityEnum.hlgt, null, this, HierarchyMode.DESCENDING)
        this.children!.push(newSOCHLGTNode);
        this.ioc?.get(MeddraService).getAll(this,EntityEnum.hlgt, `soc_code:eq:${this.data.model.code}`).subscribe(
            {
                next: (data:any) => {
                    newSOCHLGTNode.data = new HLGTListView(data.result);
                    data.result.forEach((i: any) => newSOCHLGTNode.children!.push(new MeddraNode(this.ioc!, new MeddraTerm(new FieldDefinition(this.ioc!).hlgtFields, i), i.name, EntityEnum.hlgt, this.ioc!.get(Art57Section).meddra.hlgtTermsTreeNode, newSOCHLGTNode, HierarchyMode.DESCENDING)))
                    newSOCHLGTNode.refreshLabel();    
                }, error: () => {
                    this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                }
            });




    }
}
